import React, { useCallback, useEffect, useState } from 'react';
import { Card, Tab } from 'react-bootstrap';

import { useCookies } from '../../../common/hooks/useCookies';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { ExamsPackageSearch } from '../../components/ExamsPackage/ExamsPackageSearch';
import { useNavigation } from '../../../common/navigation';
import { TabsHistory } from '../../../app/components/TabsHistory';

export const ExamsPackageView: React.FC = () => {
  const spd = useSpdCore();
  const cookies = useCookies();
  const nav = useNavigation();

  const [refresh, setRefresh] = useState(true);

  useEffect(() => {
    if (cookies.activeMonitor !== '') {
      cookies.setActiveMonitor('');
    }
  }, [cookies]);

  useEffect(() => {
    const interval = setInterval(() => setRefresh(prev => !prev), 300000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  const handleClick = useCallback(
    async (id: string) => {
      void nav.examsInPackage(id);
    },
    [nav],
  );

  const onRefresh = () => {
    setRefresh(prev => !prev);
  };

  const getDataMultiple = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) =>
      spd.examsPackage.getAllMulitipleByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
        onRefresh,
      ),
    [spd.examsPackage],
  );

  const getDataMultipleWithWaiting = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) =>
      spd.examsPackage.getAllMulitipleByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
        onRefresh,
        true,
      ),
    [spd.examsPackage],
  );

  const getDataSingle = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) =>
      spd.examsPackage.getAllSingleByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
        onRefresh,
      ),
    [spd.examsPackage],
  );

  const getCountMultiple = useCallback(
    (filterText?: string, filterColumns?: string) =>
      spd.examsPackage.getAllMulitipleCount(filterText, filterColumns),
    [spd.examsPackage],
  );

  const getCountMultipleWithWaiting = useCallback(
    (filterText?: string, filterColumns?: string) =>
      spd.examsPackage.getAllMulitipleCount(filterText, filterColumns, true),
    [spd.examsPackage],
  );

  return (
    <Card>
      <TabsHistory
        activeKey="examsPackageMulitiple"
        id="examsPackage"
        className="mb-3"
      >
        <Tab
          eventKey="examsPackageMulitiple"
          title="Paczki badań zbiorcze"
          className="m-3"
        >
          <ExamsPackageSearch
            getData={getDataMultiple}
            getCount={getCountMultiple}
            onRowClick={handleClick}
            refresh={refresh}
          />
        </Tab>
        <Tab
          eventKey="examsPackageMulitipleWithWaiting"
          title="Zbiorcze paczki z oczekującymi badaniami"
          className="m-3"
        >
          <ExamsPackageSearch
            getData={getDataMultipleWithWaiting}
            getCount={getCountMultipleWithWaiting}
            onRowClick={handleClick}
            refresh={refresh}
          />
        </Tab>
        <Tab eventKey="examsPackageSingle" title="pojedyncze" className="m-3">
          <ExamsPackageSearch
            getData={getDataSingle}
            getCount={spd.examsPackage.getAllSingleCount}
            onRowClick={handleClick}
            refresh={refresh}
          />
        </Tab>
      </TabsHistory>
    </Card>
  );
};
